// stores/checkoutStore.ts
import { defineStore } from 'pinia'
import { useCheckoutViewModel } from '@/features/checkout/dtos/useCheckoutViewModel'

export const useCheckoutStore = defineStore('checkout', () => {
    return useCheckoutViewModel()
})
